import { useEffect } from "react"
import { useAtomValue } from "jotai"
import { projectAtom } from "@/store/project/projects-state"
import { isViteReloading } from "@/utils/vite-reload"
import { isElectronApp } from "@/utils/electron"

export function useProjectBeforeUnload() {
	const project = useAtomValue(projectAtom)

	useEffect(() => {
		if (!project) {
			return
		}

		const handleBeforeUnload = (event: BeforeUnloadEvent) => {
			if (isViteReloading()) {
				return
			}

			if (isElectronApp) {
				return
			}

			event.preventDefault()
			event.returnValue = ""
		}

		window.addEventListener("beforeunload", handleBeforeUnload)
		return () => {
			window.removeEventListener("beforeunload", handleBeforeUnload)
		}
	}, [project])
}
